import * as Yup from 'yup'

import { HomeIssueType } from '@/types/HomeIssue'

export const initialValues = {
  homeLocationId: undefined,
  homeInventoryItemId: undefined,
  notes: '',
  type: undefined,
}

export const formSchema = Yup.object().shape({
  homeId: Yup.number().required('A Home is required to submit a Home Issue.'),
  homeInventoryItemId: Yup.number().when(['type'], {
    is: (type: HomeIssueType) => type === HomeIssueType.DAMAGE || type === HomeIssueType.REPLACEMENT_NEEDED,
    then: () =>
      Yup.number().required('Damage and Replacement Needed Issues require an associated Home Inventory Item.'),
  }),
  homeLocationId: Yup.number().required('A Home Location is required to submit a Home Issue.'),
  notes: Yup.string(),
  type: Yup.mixed<HomeIssueType>()
    .oneOf(Object.values(HomeIssueType))
    .required('An Issue Type is required to submit a Home Issue.'),
})

type InitialFormValues = typeof initialValues

export interface FormValuesType extends InitialFormValues {
  attachments?: []
  homeId: number
}
